export const LINKS = {
	PRODUCTS: '/products',
	APPLICATIONS: '/applications',
	ABOUT: '/about-us',
	MEDIA: '/media',
	PRODUCT_HELP: '/product-help',
	PRODUCT_CUSTOMISATION: '/product-customisation',
	SUPPORT: '/support',
	CAREERS: '/careers',
	CONTACT: '/contact',
	PRIVACY_POLICY: '/privacy-policy',
	TERMS_CONDITIONS: '/terms-and-conditions',
};

export const NAVIGATION = [
	{
		label: 'Products',
		to: LINKS.PRODUCTS,
		onClick: true,
		icon: 'grid',
	},
	{
		label: 'Applications',
		to: LINKS.APPLICATIONS,
		icon: 'arrow',
	},
	{
		label: 'About us',
		to: LINKS.ABOUT,
		icon: 'arrow',
	},
	{
		label: 'Media',
		to: LINKS.MEDIA,
		icon: 'arrow',
	},
];

export const NAVIGATION_MOBILE = [
	{
		label: 'Products',
		to: LINKS.PRODUCTS,
		onClick: true,
		icon: 'grid',
	},
	{
		label: 'Applications',
		to: LINKS.APPLICATIONS,
		icon: 'arrow',
	},
	{
		label: 'About us',
		to: LINKS.ABOUT,
		icon: 'arrow',
	},
	{
		label: 'Product help',
		to: LINKS.PRODUCT_HELP,
		icon: 'arrow',
	},
	{
		label: 'Support',
		to: LINKS.SUPPORT,
		icon: 'arrow',
	},
	{
		label: 'Careers',
		to: LINKS.CAREERS,
		icon: 'arrow',
	},
	{
		label: 'Contact',
		to: LINKS.CONTACT,
		icon: 'arrow',
	},
];

export const SUB_NAVIGATION_HEADER = [
	{
		label: 'Product help',
		to: LINKS.PRODUCT_HELP,
	},
	{
		label: 'Support',
		to: LINKS.SUPPORT,
	},
	{
		label: 'Contact',
		to: LINKS.CONTACT,
	},
];

export const SUB_NAVIGATION_FOOTER = [
	{
		label: 'Careers',
		to: LINKS.CAREERS,
	},
	{
		label: 'Media',
		to: LINKS.MEDIA,
	},
	{
		label: 'Product help',
		to: LINKS.PRODUCT_HELP,
	},

	{
		label: 'Support',
		to: LINKS.SUPPORT,
	},
];

export const LEGAL_NAVIGATION = [
	{
		label: 'Privacy Policy',
		to: LINKS.PRIVACY_POLICY,
	},
	{
		label: 'Terms & Conditions',
		to: LINKS.TERMS_CONDITIONS,
	},
];

export const PRODUCT_CATEGORIES = [
	'rotary-feedthroughs',
	'linear-actuators',
	'sample-transfer-arms',
	'port-aligners',
	'sample-parking',
	'rtta',
	'wobble-sticks',
	'xyz',
	'push-pull-devices',
	'analytical-stages',
	'deposition-stages',
	'heater-modules',
	'viewport-shutters',
	'heater-power-supplies',
	'motion-controllers',
];

export const PRODUCT_GROUPS = [
	'solid-magidrive-series',
	'hollow-magidrive-series',
	'bellows-sealed-linear-actuators',
	'linear-actuators-edge-welded-bellows-sealed-devices',
	'magnetically-coupled-linear-actuators',
	'push-pull-edge-welded-bellows-sealed-devices',
	'magnetically-coupled-devices',
];

export const PRODUCT_ORDERING = [
	'md10-solid-range',
	'md16n-md16a-solid-range',
	'md40n-md40a-solid-range',
	'md40-solid-range',
	'md64-solid-range',
	'md40h-hollow-range',
	'md35lb-hollow-range',
	'md64h-hollow-range',
	'md64lb-m-hollow-range',
	'md100h-hollow-range',
	'hollow-drive-with-lift-and-lower',
	'magidrive-customisation-options',
	'standard-linear-shift-lsm-hlsm',
	'compact-linear-shift-clsm',
	'linear-shift-with-integrated-tilt-lsmt',
	'linear-shift-with-integrated-x-shift-lsmx',
	'long-travel-linear-shift-mechanism-hlsml',
	'high-speed-linear-shift-mechanism-plsm',
	'linear-shift-customisation-options',
	'albd-linear-bellows-drive',
	'magnetically-coupled-linear-drive-mppl',
	'pneumatic-linear-actuator',
	'ballscrew-linear-actuator',
	'port-aligner-range',
	'linear-transfer-arm',
	'linear--rotary-magnetically-coupled-transfer-arm',
	'the-dapp--xdapp-range',
	'the-elevating-powerprobe-transforms-conventional-approaches',
	'linear-and-rotary-motion-with-a-unique-sample-gripping',
	'transfer-with-180-degree-orientation',
	'xpp-option',
	'spp-option',
	'flag-sample-transfer-options',
	'puck-sample-transfer-options',
	'power-probe-customisation-options',
	'linear-telescopic-transfer-arm',
	'2-axis-rtta',
	'3-axis-rtta',
	'ws40-range',
	'wsg40-range',
	'xws40-range',
	'ws40-range',
	'xwsg40-range',
	'single-axis-y-shift',
	'xy-aligner',
	'precision-xy-manipulators',
	'configured-xyz',
	'compact-xyz-manipulator',
	'y-xy-xyz-customisation-options',
	'albd-linear-bellows-drive-push-pull',
	'mpp-linear-unguided-motion',
	'mpprl-rotary-and-linear-motion',
	'mpprl-rotary-and-linear-motion',
	'light-source-pneumatically-actuated-drive',
	'xl-t-multicentre',
	'xl-r-multicentre',
	'configuration-options',
	'state-of-the-art-performance-for-growth-and-deposition',
	'cooled-ec-i-series',
	'continuous-substrate-rotation-tilt-heating-and-electrical',
	'eps-series',
	'glad-series',
	'view-port-shutters',
	'shutter-actuators',
	'hand-held-dc-controller',
	'modular-stepper-motor-controller',
];
